import React from 'react';
const SettingsIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1m17.25-8.25L19.5 6m-3 12L14.25 20.25M6.75 3.75L4.5 6m3 12l-2.25 2.25" />
  </svg>
);
export default SettingsIcon;